import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";
export default class CreditWallet extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "credit-wallet";
    static pluralName = "credit-wallets";
    static displayName = "Credit Wallet";
    constructor() { super(`${CreditWallet.kind}`, `${CreditWallet.singularName}`, `${CreditWallet.pluralName}`); }
    async getAll(query = {}) { return await this.fetch(qs.stringify({...query}, {encodeValuesOnly: true})); }
    async getById(id, query = {}) { return await this.find(id, {populate: "*", ...query}); }
    async ensureMine() { return await this.postAction("/credit-wallets/ensure"); }
}
